<template>
  <div class="add-property">
    <v-container>
      <h2 class="grey--text">Editar propiedad</h2>
      <v-card class="mx-auto mt-4 pa-4" outlined>
        <v-card-title class="pa-0">Generales</v-card-title>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-text-field label="Título de la propiedad" v-model="form.title"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select :items="developments" label="Desarrollo" v-model="form.development"></v-select>
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea label="Descripción" v-model="form.description"></v-textarea>
              </v-col>
              <v-col cols="12" md="4">
                <v-radio-group
                  v-model="form.highlightModel"
                  row
                >
                  <span class="mr-2">Modelo destacados:</span>
                  <v-radio
                    label="Si"
                    v-bind:value="true"
                  ></v-radio>
                  <v-radio
                    label="No"
                    v-bind:value="false"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="4">
                <v-select :items="distintive" label="Distintivo" v-model="form.distinctive" item-text="text" item-value="value"></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Precio" prefix="$" v-model="form.price"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-radio-group
                  v-model="form.showPrice"
                  row
                >
                  <span class="mr-2">Mostrar precio:</span>
                  <v-radio
                    label="Si"
                    v-bind:value="true"
                  ></v-radio>
                  <v-radio
                    label="No"
                    v-bind:value="false"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="4">
                <v-select :items="types" label="Tipo de construcción" v-model="form.typeOfConstruction"></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Medias del lote" suffix="m" v-model="form.landSquareMeters"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Metros cuadrados de construcción" suffix="㎡" v-model="form.constructionSquareMeters"></v-text-field>
              </v-col>   
              <v-col cols="12" md="4">
                <v-radio-group
                  v-model="form.showVirtual"
                  row
                >
                  <span class="mr-2">Mostrar Recorrido:</span>
                  <v-radio
                    label="Si"
                    v-bind:value="true"
                  ></v-radio>
                  <v-radio
                    label="No"
                    v-bind:value="false"
                  ></v-radio>
                </v-radio-group>
              </v-col> 
              <v-col cols="12" md="4">
                <v-radio-group
                  v-model="form.showYoutube"
                  row
                >
                  <span class="mr-2">Mostrar Video:</span>
                  <v-radio
                    label="Si"
                    v-bind:value="true"
                  ></v-radio>
                  <v-radio
                    label="No"
                    v-bind:value="false"
                  ></v-radio>
                </v-radio-group>
              </v-col>         
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-text-field type="number" label="Recámaras" v-model="form.rooms"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field type="number" label="Baños" v-model="form.bathrooms"></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="form.age"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.age"
                      label="Año de construcción"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.age" type="month" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(form.age)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col
              cols="12"
              sm="4"
              md="4"
            >
              <v-checkbox
                v-model="form.extras"
                label="Cochera"
                value="Cochera"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="form.extras"
                label="Cochera techada"
                value="Cochera techada"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="form.extras"
                label="Recámara en planta baja"
                value="Recámara en planta baja"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="form.extras"
                label="Área para TV"
                value="Área para TV"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="form.extras"
                label="Estudio"
                value="Estudio"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="4"
            >
              <v-checkbox
                v-model="form.extras"
                label="Cuarto de servicio"
                value="Cuarto de servicio"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="form.extras"
                label="Patio"
                value="Patio"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="form.extras"
                label="Pasillo de servicio"
                value="Pasillo de servicio"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="form.extras"
                label="Recámara principal con baño completo"
                value="Recámara principal con baño completo"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="form.extras"
                label="Recámara principal con baño completo y vestidor"
                value="Recámara principal con baño completo y vestidor"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="4"
            >
              <v-checkbox
                v-model="form.extras"
                label="Cocina"
                value="Cocina"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="form.extras"
                label="Sala / Comedor"
                value="Sala / Comedor"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="form.extras"
                label="Bodega"
                value="Bodega"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="form.extras"
                label="Recámara principal con baño completo, vestidor y balcón"
                value="Recámara principal con baño completo, vestidor y balcón"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="form.extras"
                label="Cuarto de lavado"
                value="Cuarto de lavado"
                hide-details
              ></v-checkbox>  
            </v-col>
              <v-col cols="12">
                <v-combobox
                  v-model="form.amenities"
                  :rules="rules.amenities"
                  :items="amenities"
                  label="Amenidades"
                  multiple
                  chips
                ></v-combobox>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Video URL" v-model="form.videoUrl"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Tour virtual" v-model="form.virtualTourUrl"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="URL" v-model="form.slug" :rules="rules.url"></v-text-field>
              </v-col>
            </v-row>
            <v-card-title class="pa-0">Imágenes</v-card-title>
            <v-row class="pb-7">
              <v-col cols="3" md="3" v-for="(url, index) in urls" :key="url">
                <div style="position:relative;">
                  <v-btn
                    color="red"
                    class="v-btn--example"
                    dark
                    top
                    right
                    small
                    fab
                    style="position:absolute;z-index:3;top:-8px;right:20px;"
                    @click="removeImage(index)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-img :src="url" max-height="144px"></v-img>
                </div>
              </v-col>
              <v-col cols="3" md="3">
                <div style="height:144px;width:100%;" class="grey lighten-3">
                  <input
                    id="file"
                    class="mb-4 add-image-btn"
                    type="file"
                    block
                    @change="addImage"
                  />
                  <label for="file" class="grey lighten-3">
                    <span>
                      <v-icon>mdi-cloud-upload</v-icon>
                    </span>
                    <br />Agregar imágenes
                  </label>
                </div>
                <p v-if="!imagesValid" class="error--text py-3">Ingresa por lo menos una imagen del desarrollo</p>
              </v-col>
            </v-row>
            
            <v-card-title class="pa-0">imágenes de banner</v-card-title>
            <v-row class="pb-7">
              <v-col cols="3" md="3" v-for="(url, index) in urlsBanner" :key="url">
                <div style="position:relative;">
                  <v-btn
                    color="red"
                    class="v-btn--example"
                    dark
                    top
                    right
                    small
                    fab
                    style="position:absolute;z-index:3;top:-8px;right:20px;"
                    @click="removeBanner(index)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-img :src="url" max-height="144px"></v-img>
                </div>
              </v-col>
              <v-col cols="3" md="3">
                <div style="height:144px;width:100%;" class="grey lighten-3">
                  <input
                    id="bannerFile"
                    class="mb-4 add-image-btn"
                    type="file"
                    block
                    multiple
                    @change="addBanner"
                  />
                  <label v-if="!bannerLoading" for="bannerFile" class="grey lighten-3">
                    <span>
                      <v-icon>mdi-cloud-upload</v-icon>
                    </span>
                    <br />Agregar imágenes
                  </label>
                  <label v-else for="bannerFile" class="grey lighten-3">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </label>
                  
                </div>
                <p v-if="!imagesValid" class="error--text py-3">Ingresa por lo menos una imagen del desarrollo</p>
              </v-col>
            </v-row>

            <v-card-title class="pa-0">imágenes mobiles del banner</v-card-title>

            <v-row class="pb-7">
              <v-col cols="3" md="3" v-for="(url, index) in urlsBannerMobile" :key="url">
                <div style="position:relative;">
                  <v-btn
                    color="red"
                    class="v-btn--example"
                    dark
                    top
                    right
                    small
                    fab
                    style="position:absolute;z-index:3;top:-8px;right:20px;"
                    @click="removeBannerMobile(index)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-img :src="url" max-height="144px"></v-img>
                </div>
              </v-col>
              <v-col cols="3" md="3">
                <div style="height:144px;width:100%;" class="grey lighten-3">
                  <input
                    id="bannerFileMobile"
                    class="mb-4 add-image-btn"
                    type="file"
                    block
                    multiple
                    @change="addBannerMobile"
                  />
                  <label v-if="!bannerMobileLoading" for="bannerFileMobile" class="grey lighten-3">
                    <span>
                      <v-icon>mdi-cloud-upload</v-icon>
                    </span>
                    <br />Agregar imágenes
                  </label>
                  <label v-else for="bannerFileMobile" class="grey lighten-3">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </label>
                </div>
                <!-- <p v-if="!imagesValid" class="error--text py-3">Ingresa por lo menos una imagen del desarrollo</p> -->
              </v-col>
            </v-row>

          </v-container>
        </v-form>
      </v-card>
      <v-btn class="my-4" color="primary" depressed @click.stop="editProperty()">Guardar</v-btn>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import constants from "../constants";
export default {
  data() {
    return {
      api: constants.API,
      id: this.$route.params.id,
      types: [
        "Ladrillo",
        "Block"
      ],
      distintive: [
        { text: 'Ninguno', value: null },
        { text: 'Bono', value: 'Bono' },
        { text: 'Entrega inmediata', value: 'Entrega inmediata' },
        { text: 'Equipamiento', value: 'Equipamiento' },
        { text: 'Terreno excedente', value: 'Terreno excedente' }
      ],
      sector: [],
      developments: [],
      amenities: [
        "Gimnasio",
        "Alberca",
        "Casa club",
        "Áreas verdes",
        "Ciclovía",
        "Fitness Park",
        "Juegos infantiles",
        "Acceso controlado",
        "Residencial privado",
        "Barda perimetral",
        "Cerca eléctrica",
        "Caseta de vigilancia",
        "Cancha de tenis",
        "Media cancha de Basketball",
        "Áreas de convivencia"
      ],
      loading: false,
      form: {
        title: null,
        description: null,
        development: null,
        highlightModel: false,
        distinctive: null,
        price: 0,
        showPrice: false,
        typeOfConstruction: null,
        landSquareMeters: null,
        constructionSquareMeters: null,
        rooms: 0,
        bathrooms: 0,
        age: new Date().toISOString().substr(0, 7),
        extras: [],
        videoUrl: null,
        virtualTourUrl: null,
        slug: null,
        amenities: [],
        showVirtual: false,
        showYoutube: false,
      },
      rules: {
        title: [v => !!v || "Titulo de la propiedad requerido"],
        description: [v => !!v || "Descripción requerida"],
        development: [v => !!v || "Desarrollo requerido"],
        type: [v => !!v || "Tipo de propiedad requerido"],
        sector: [v => !!v || "Sector requerido"],
        landSquareMeters: [v => !!v || "Metros cuadrados requerido"],
        rooms: [v => !!v || "Número de cuartos requerido"],
        garage: [v => !!v || "Cochera para autos requerido"],
        bathrooms: [v => !!v || "Número de baños requerido"],
        age: [v => !!v || "Fecha de construcción requerido"],
        amenities: [v => v.length !== 0 || "Agrega por lo menos una amenidad"],
        url: [v => !!v || "URL requerida"]
      },
      valid: true,
      menu: false,
      selectedFile: null,
      property: {},
      imagesValid: true,
      selectedFileBanner: null,
      selectedFileBannerMobile: null,
      urls: [],
      urlsBanner: [],
      urlsBannerMobile: [],
      images: [],
      banners: [],
      bannersDB: [],
      mobileBanners: [],
      imageLoading: false,
      bannerLoading: false,
      bannerMobileLoading: false,
      listImagesNames : [],
      listImagesBannerNames : [],
      listImagesMovilNames : [],
      PATH_IMAGE_SERVER : 'api/images/property',
      PATH_IMAGE        : 'images',
    };
  },
  mounted() {
    this.getProperty();
    this.getDevelopments();
  },
  methods: {
    getDevelopments() {
      this.$http
        .get("development/")
        .then((res) => {
          this.developments = res.data.data;

          this.developments = this.developments.map((item) => {
            return { text: item.title, value: item._id };
          });
        })
        .catch((error) => console.log(error));
    },
    getProperty() {
      var vm = this;

      this.$http
        .get(`property/${this.id}`)
        .then((res) => {
          let data = res.data.data;

          this.form.title = data.title;
          this.form.development = data.development._id;
          this.form.description = data.description;
          this.form.highlightModel = data.highlightModel;
          this.form.distinctive = data.distinctive;        
          this.form.price = data.price;
          this.form.showPrice = data.showPrice;
          this.form.typeOfConstruction = data.typeOfConstruction;  
          this.form.landSquareMeters = data.landSquareMeters;
          this.form.constructionSquareMeters = data.constructionSquareMeters;
          this.form.rooms = data.rooms;
          this.form.bathrooms = data.bathrooms;
          this.form.extras = data.extras;
          this.form.amenities = data.amenities;
          this.form.videoUrl = data.videoUrl;
          this.form.virtualTourUrl = data.virtualTourUrl;
          this.form.slug = data.slug;
          this.form.age = data.age;
          this.form.showVirtual = data.showVirtual;
          this.form.showYoutube = data.showYoutube;
          
          this.images         = data.images;
          this.imagesDB       = data.imagesDB;
          this.banners        = data.bannerImages;
          this.bannersDB      = data.bannerImagesDB;
          this.mobileBanners  = data.bannerImagesMobile;
          this.mobileBannersDB= data.bannerImagesMobileDB;

          this.addToArrayImages(this.images);
          this.addToArrayImages(this.imagesDB, true);

          this.addToArrayImagesBanner(this.banners);
          this.addToArrayImagesBanner(this.bannersDB, true);

          this.addToArrayImagesMovil(this.mobileBanners);
          this.addToArrayImagesMovil(this.mobileBannersDB, true);
        })
        .catch((error) => console.log(error));
    },
    editProperty() {
      console.log(this.form);
      this.$http
        .put(`property/${this.id}`, this.form)
        .then((res) => {
          this.$store.commit("SNACKBAR", {
            text: "Propiedad editada con éxito",
            type: "success",
            isShow: true
          });
          this.$router.replace("/properties");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addToArrayImages(listImages, isDB = false){
      for (const image of listImages) {
        let url = `${this.api}${this.PATH_IMAGE}/${image}`;
        this.listImagesNames.push(image);
        this.urls.push(url);
      }
    },
    addToArrayImagesBanner(listImages, isDB = false){
      for (const image of listImages) {
        let url = `${this.api}${this.PATH_IMAGE}/${image}`;
        this.listImagesBannerNames.push(image);
        this.urlsBanner.push(url);
      }
    },
    addToArrayImagesMovil(listImages, isDB = false){
      for (const image of listImages) {
        let url = `${this.api}${this.PATH_IMAGE}/${image}`;
        this.listImagesMovilNames.push(image);
        this.urlsBannerMobile.push(url);
      }
    },
    addImage(e) {
      const formData = new FormData();

      this.selectedFile = e.target.files[0];

      formData.append("image", this.selectedFile)

      this.$http
        .put(`property/addImage/${this.id}`, formData)
        .then((res) => {
          this.onImageEdit('Imagen agregada con éxito');
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removeImage(index) {
      this.$http
        .put(`property/removeImage/${this.id}`, null, { params: { image: this.listImagesNames[index] }})
        .then((res) => {
          this.onImageEdit('Imagen eliminada con éxito');
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addBanner(e) {
      this.bannerLoading = true
      
      const formData = new FormData();

      this.selectedFileBanner = e.target.files[0];
      formData.append("image", this.selectedFileBanner)

      this.$http
        .put(`property/addBannerImage/${this.id}`, formData)
        .then((res) => {
          this.onImageEdit('Imagen agregada con éxito');  
          this.bannerLoading = false        
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removeBanner(index) {
      this.$http
        .put(`property/removeBannerImage/${this.id}`, null, { params: { image: this.listImagesBannerNames[index] }})
        .then((res) => {
          this.onImageEdit('Imagen eliminada con éxito');
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addBannerMobile(e) {
      this.bannerMobileLoading = true
      
      const formData = new FormData();

      this.selectedFileBannerMobile = e.target.files[0];
      formData.append("image", this.selectedFileBannerMobile)

      this.$http
        .put(`property/addBannerImageMobile/${this.id}`, formData)
        .then((res) => {
          this.onImageEdit('Imagen agregada con éxito');  
          this.bannerMobileLoading = false        
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removeBannerMobile(index) {
      this.$http
        .put(`property/removeBannerImageMobile/${this.id}`, null, { params: { image: this.listImagesMovilNames[index] }})
        .then((res) => {
          this.onImageEdit('Imagen eliminada con éxito');
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onImageEdit(text) {
      this.$store.commit("SNACKBAR", {
        text: text,
        type: "success",
        isShow: true
      });
      
      this.urls = [];
      this.urlsBanner = [];
      this.urlsBannerMobile = [];

      this.getProperty();
      this.getDevelopments();
      
    }
  },
};
</script>

<style scoped>
.add-image-btn {
  display: none;
}

label {
  padding: 40px;
  height: 100%;
  width: 100%;
  border-radius: 4px;
  text-align: center;
  font-weight: 500;
  font-size: 1.1rem;
  display: block;
  cursor: pointer;
}

.v-btn--example {
  bottom: 0;
  position: absolute;
  margin: 0px -24px 0px 0px;
}
</style>
